<mat-sidenav-container  class="motivationsView_main-container" >        
<mat-sidenav #moovSideNav class="motivationsView_activeMoovSideNav" [ngClass]="{'is-mobile-view': isMobileView}" (closedStart)="onSidebarClose()">
        <app-motivation-view [showClose]="true" [selectedMotivationId]="selectedMotivationId" (closeSideNavEvent)="closeMotivationSideNav()"></app-motivation-view>
</mat-sidenav>
<mat-sidenav-content class="motivationsView_sideNavContentContainer" [ngClass]="{'is-mobile-view': isMobileView}">
<div class="motivationsContainer" [ngClass]="{'is-mobile-view': isMobileView}">
    <div class="topPart">         
        <span class="header">{{'motivations.header' | translate}}</span>
        <span><mat-divider class="divider"></mat-divider></span>
    </div>
    <div class="allMotivationsGrid">
        <app-claro-big-label class="motivationsView_motivationItem"  [ngClass]="{'is-mobile-view': isMobileView}" *ngFor="let currMotivation of motivationsList" [height]="isMobileView? '3em':'6em'" [width]="isMobileView? '9em':'12em'" [fontSize]="isMobileView? '18px':'21px'" [iconFontSize]="isMobileView? '24px':'40px'" [colorScheme]="currMotivation.color" [iconPath]="currMotivation.imageUrl" [labelText]="currMotivation.name" (click)="openMotivation(currMotivation.id)"></app-claro-big-label>
    </div>
</div>
</mat-sidenav-content>
</mat-sidenav-container>
